/**
 * DirectoryPicker — shows the folder chooser. That is its entire job.
 */

import { BrowserFsDirectory } from './browser-fs';

export interface PickedDirectory {
  directory: BrowserFsDirectory;
  handle: FileSystemDirectoryHandle;
}

type PickerWindow = Window & {
  showDirectoryPicker?: (opts?: {
    mode?: 'read' | 'readwrite';
    startIn?: string;
    id?: string;
  }) => Promise<FileSystemDirectoryHandle>;
};

export class DirectoryPicker {
  /** False in Safari and Firefox, which have no folder picker at all. */
  static get isSupported(): boolean {
    return typeof window !== 'undefined' && 'showDirectoryPicker' in window;
  }

  /** Returns null when the photographer dismisses the dialog. */
  async pick(mode: 'read' | 'readwrite' = 'read', id?: string): Promise<PickedDirectory | null> {
    const picker = (window as PickerWindow).showDirectoryPicker;
    if (!picker) throw new Error('This browser cannot open folders.');

    try {
      const handle = await picker({ mode, id });
      return { directory: new BrowserFsDirectory(handle), handle };
    } catch (err) {
      if (err instanceof DOMException && err.name === 'AbortError') return null;
      throw err;
    }
  }
}
